import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

// Component to manage PWA manifest based on route
export default function AdminPWAManager() {
  const location = useLocation();
  
  useEffect(() => {
    const isAdminRoute = location.pathname.startsWith('/admin');
    const existingManifest = document.querySelector('link[rel="manifest"]');
    const existingAppleTouchIcon = document.querySelector('link[rel="apple-touch-icon"]');
    const existingThemeColor = document.querySelector('meta[name="theme-color"]');
    const existingAppTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    
    if (isAdminRoute) {
      // Update manifest for Admin PWA
      if (existingManifest) {
        existingManifest.href = '/admin-manifest.json';
      }
      if (existingAppleTouchIcon) {
        existingAppleTouchIcon.href = '/icons/admin/admin-icon-192.png';
      }
      if (existingAppTitle) {
        existingAppTitle.content = 'RTS Admin';
      }
      // Update document title
      document.title = 'RTS Admin Panel';
    } else {
      // Restore default manifest for public site
      if (existingManifest) {
        existingManifest.href = '/manifest.json';
      }
      if (existingAppleTouchIcon) {
        existingAppleTouchIcon.href = '/icons/icon-192x192.png';
      }
      if (existingAppTitle) {
        existingAppTitle.content = 'RTS Express';
      }
    }
  }, [location.pathname]);
  
  return null;
}

// Hook to use PWA install prompt
export function usePWAInstall() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);
  
  useEffect(() => {
    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsInstalled(true);
      return;
    }
    
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsInstallable(true);
    };
    
    const handleAppInstalled = () => {
      setIsInstalled(true);
      setIsInstallable(false);
      setDeferredPrompt(null);
    };
    
    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    window.addEventListener('appinstalled', handleAppInstalled);
    
    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
      window.removeEventListener('appinstalled', handleAppInstalled);
    };
  }, []);
  
  const promptInstall = async () => {
    if (!deferredPrompt) {
      return { outcome: 'unavailable' };
    }
    
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      setIsInstallable(false);
    }
    setDeferredPrompt(null);
    
    return { outcome };
  };
  
  return { isInstallable, isInstalled, promptInstall };
}
